import { useState } from 'react';
import { useDataTableHandle } from '../DataTable';
import OrderFormUploadTable from './OrderFormUploadTable';
import {
  postOrderFormsMasterDataDownloadFile,
  postOrderFormsMasterDataFilesLazy,
  postOrderFormsRulesDocument,
} from '../apiCalls';
import UploadField from '../UploadField';
import { useDataTableData } from '../../hooks/useDataTableData';
import { Buffer } from 'buffer';

const OrderFormUpload = ({ setShowToast, setRefreshProductsData, dthProducts, setNewOrderForm, lastUpdated }) => {
  const [persist, setPersist] = useState({});
  const [paginationLoaded, setPaginationLoaded] = useState(false);
  const [refreshData, setRefreshData] = useState({});

  const dth = useDataTableHandle();

  async function updateData(setPaginationLength, pagination, sortStatus, search, filter) {
    setRefreshData({
      pagination,
      sortStatus,
      search,
      filter,
      setPaginationLength,
    });
  }

  const { data } = useDataTableData(dth, refreshData, postOrderFormsMasterDataFilesLazy, paginationLoaded);

  const handleButtonClick = async (blobTitle) => {
    const formData = new FormData();
    formData.append('file', blobTitle);
    const data = await postOrderFormsMasterDataDownloadFile(formData);

    if (data?.buffer?.data) {
      const dataBuffered = Buffer.from(data.buffer.data, 'binary').toString('base64');

      const fileData = atob(dataBuffered);
      const fileArray = new Uint8Array(fileData.length);
      for (let i = 0; i < fileData.length; i++) {
        fileArray[i] = fileData.charCodeAt(i);
      }
      const blob = new Blob([fileArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = fileUrl;
      a.download = blobTitle;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(fileUrl);
        a.remove();
      }, 0);
    } else {
      setShowToast({
        toastTitle: 'Error',
        toastBody: 'There was an error downloading the file',
      });
    }
  };

  const refreshDataFromUpload = () => {
    updateData({
      amount: dth.current.pagination.itemsPerPage,
      pagination: {
        pageNo: 0,
        itemsPerPage: dth.current.pagination.itemsPerPage,
      },
    });
    setRefreshProductsData({
      amount: dthProducts.current.pagination.itemsPerPage,
      pagination: {
        pageNo: 0,
        itemsPerPage: dthProducts.current.pagination.itemsPerPage,
      },
    });
  };

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto auto' }}>
        <h1 className="floating-box-header-general">Order Form Table - Upload</h1>
        <p className="floating-box-header-general" style={{ fontSize: '1rem', alignItems: 'end', marginRight: '15px' }}>
          Last Updated: {lastUpdated || ''}
        </p>
      </div>
      <UploadField
        refreshData={refreshDataFromUpload}
        setShowToast={setShowToast}
        postDocumentFunction={postOrderFormsRulesDocument}
      />
      <OrderFormUploadTable
        handleClose={() => {
          setNewOrderForm(null);
        }}
        data={data}
        dth={dth}
        updateData={updateData}
        setPaginationLoaded={setPaginationLoaded}
        persist={persist}
        setPersist={setPersist}
        handleButtonClick={handleButtonClick}
      />
    </>
  );
};

export default OrderFormUpload;
